import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateProfileContactRequest } from '../../api/update-profile-contact/updateProfileContact.types';
import type { UseUpdateProfileContactResult } from './useUpdateProfileContact.types';

import { updateProfileContact } from '../../api/update-profile-contact/updateProfileContact';

export function useUpdateProfileContact(): UseUpdateProfileContactResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateProfileContactRequest>({
    mutationFn: updateProfileContact,
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({ queryKey: ['client-profiles'] });
    },
  });
}
